import React, { useEffect, useState } from 'react';

import {
	AutocompleteProps,
	Container,
	Input,
	SectionTitle,
	SuggestionItem,
	SuggestionsList,
} from './styles';

const Autocomplete: React.FC<AutocompleteProps> = ({ suggestions, pick, placeholder, value }) => {
	const [filteredSuggestions, setFilteredSuggestions] = useState<string[]>([]);
	const [groupedSuggestions, setGroupedSuggestions] = useState<Record<string, string[]>>({});
	const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
	const [showSuggestions, setShowSuggestions] = useState(false);
	const [inputValue, setInputValue] = useState(value || '');

	useEffect(() => {
		if (suggestions) {
			// Agrupar las sugerencias por la primera letra
			const grouped = suggestions?.reduce((acc, suggestion) => {
				const firstLetter = suggestion.charAt(0).toUpperCase();
				if (!acc[firstLetter]) acc[firstLetter] = [];
				acc[firstLetter].push(suggestion);
				return acc;
			}, {} as Record<string, string[]>);

			setGroupedSuggestions(grouped);
			setFilteredSuggestions(suggestions); // Mostrar todas las sugerencias inicialmente
		}
	}, [suggestions]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const userInput = e.currentTarget.value;
		setInputValue(userInput);
		if (suggestions != undefined) {
			// Filtrar las sugerencias basadas en el input
			const filtered = suggestions.filter(
				(suggestion) => suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
			);
			setFilteredSuggestions(filtered);
			setActiveSuggestionIndex(0);
			setShowSuggestions(true);
		}
		setShowSuggestions(true);
	};

	const handleClick = (suggestion: string) => {
		if (suggestion !== undefined && suggestion !== '' && typeof pick === 'function') {
			pick(suggestion);
		}
		setInputValue(suggestion);
		setFilteredSuggestions([]);
		setShowSuggestions(false);
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			if (
				filteredSuggestions[activeSuggestionIndex] !== undefined &&
				filteredSuggestions[activeSuggestionIndex] !== '' &&
				typeof pick === 'function'
			) {
				pick(filteredSuggestions[activeSuggestionIndex]);
			}
			setInputValue(filteredSuggestions[activeSuggestionIndex]);
			setShowSuggestions(false);
		} else if (e.key === 'ArrowUp') {
			if (activeSuggestionIndex > 0) {
				setActiveSuggestionIndex(activeSuggestionIndex - 1);
			}
		} else if (e.key === 'ArrowDown') {
			if (activeSuggestionIndex < filteredSuggestions.length - 1) {
				setActiveSuggestionIndex(activeSuggestionIndex + 1);
			}
		}
	};

	return (
		<Container>
			<Input
				type="text"
				onChange={handleChange}
				onKeyDown={handleKeyDown}
				value={inputValue}
				placeholder={placeholder || "Buscar..."}
			/>
			{showSuggestions && (
				<SuggestionsList>
					{Object.keys(groupedSuggestions)
						.filter((letter) =>
							groupedSuggestions[letter].some((suggestion) =>
								suggestion.toLowerCase().includes(inputValue.toLowerCase()),
							),
						)
						.map((letter) => (
							<React.Fragment key={letter}>
								<SectionTitle>{letter}</SectionTitle>
								{groupedSuggestions[letter]
									.filter((suggestion) =>
										suggestion.toLowerCase().includes(inputValue.toLowerCase()),
									)
									.map((suggestion, index) => (
										<SuggestionItem
											key={suggestion}
											onClick={() => handleClick(suggestion)}
											isActive={index === activeSuggestionIndex}
										>
											{suggestion}
										</SuggestionItem>
									))}
							</React.Fragment>
						))}
				</SuggestionsList>
			)}
		</Container>
	);
};

export default Autocomplete;
